import { request } from './client.js';
import type { SessionUser } from '../state/session.js';

export interface AuthBundle {
  user: SessionUser;
  accessToken: string;
  refreshToken: string;
}

export function login(input: { email: string; password: string }): Promise<AuthBundle> {
  return request<AuthBundle>('/auth/login', { method: 'POST', body: input, auth: false });
}

export function logout(refreshToken: string): Promise<{ ok: boolean }> {
  return request('/auth/logout', { method: 'POST', body: { refreshToken } });
}
